export default "__VITE_ASSET__T3YYWBCi__"